<template>
    <div class="page-header-top">
        <div class="container-fluid">
            <div class="page-logo" style="min-width:340px;">
                <h3>
                    <img v-if="appLogo" :src="appLogo" :alt="project" class="logo-smart">
                    <span v-else>{{ project }}</span>
                    <span>{{ this.$root.title }}</span>
                    <span v-if="environment !== 'production'" class="environment">{{environment.charAt(0).toUpperCase() + environment.slice(1)}}</span>
                </h3>
            </div>

            <a href="javascript:;" @click="toggleMobileMenu" class="menu-toggler"></a>
            <div class="top-menu">
                <ul class="nav navbar-nav pull-right">
                    <li class="dropdown dropdown-user dropdown-dark">
                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
                            <img alt="" class="img-circle" :src="`/img/avatar/avatar_kote.png`">
                            <span class="username username-hide-mobile">{{ $root.user.name }}</span>
                        </a>
                    </li>
                    <!-- BEGIN QUICK SIDEBAR TOGGLER -->
                    <li class="dropdown dropdown-extended quick-sidebar-toggler">
                        <span class="sr-only">Toggle Quick Sidebar</span>
                        <a data-testid="logout" class="logout" href="/logout"><icon name="faSignOut" size="19" color="inherit" /></a>
                    </li>
                </ul>
            </div>
            <notification v-if="hasPermission('user.notifications')"></notification>
            <div class="chat-btn-wrap" v-if="hasPermission('user.ai-chat')">
                <div class="chat-btn" @click="toggleAIChat">
                    <div class="ai-logo">
                        <img width="20" src="../../images/smarty-ai-logo.png" alt="">
                    </div>
                    <div class="text">Smarty AI</div>
                </div>
            </div>
        </div>
        <AIChat ref="aiChat" :is-visible="isAIChatVisible" v-if="hasPermission('user.ai-chat')" @toggle="toggleAIChat"/>
    </div>
</template>

<script>
import AIChat from "@/js/components/AIChat.vue";
import Notification from "@/js/components/Notification.vue";
import { hasPermission } from '@/js/services/auth-service';

export default {
    name: "AppHeaderTop",
    components: {AIChat, Notification},

    data: () => ({
        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,
        environment: import.meta.env.VITE_APP_ENV,
        isAIChatVisible: false,
    }),
    mounted() {
        this.$eventBus.$on('aiHealthCheck', this.startAIHealthCheck);
    },
    beforeDestroy() {
        this.$eventBus.$off('aiHealthCheck', this.startAIHealthCheck);
    },
    methods: {
        hasPermission,
        startAIHealthCheck(payload) {
            this.isAIChatVisible = true;
            this.$refs.aiChat?.startHealthCheck(payload);
        },
        toggleMobileMenu: function() {
            this.$emit('toggle-mobile-menu');
        },
        toggleAIChat: function() {
            this.isAIChatVisible = !this.isAIChatVisible;
        }
    }
}
</script>
